import { useMemo } from "react";
import { Modifydetail } from "../../../../../../redux/apiSpecifications/apiCrud";
import { useTranslation } from "react-i18next";

interface IAppraiserAssignedDescriptionProps {
    modifyDetailsJson: Modifydetail[];
}

const AppraiserAssignedDescription = ({
    modifyDetailsJson,
}: IAppraiserAssignedDescriptionProps) => {
    const { t } = useTranslation();

    const appraiserFullName: string = useMemo(() => {
        const value = modifyDetailsJson.find(
            (_) => _.key === "appraiser_full_name"
        );

        return value?.value ?? "";
    }, [modifyDetailsJson]);

    return (
        <>
            {t("historical-actions-appraiser-assigned-description", {
                appraiser_full_name: appraiserFullName,
            })}
        </>
    );
};

export default AppraiserAssignedDescription;
